import script from "./HandArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./HandArrow.vue?vue&type=script&setup=true&lang=js"

import "./HandArrow.vue?vue&type=style&index=0&id=685180e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685180e1"]])

export default __exports__